import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { getCalApi } from "@calcom/embed-react";

interface CalBookingButtonProps {
  className?: string;
}

export function CalBookingButton({ className }: CalBookingButtonProps) {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: "30min" });
      cal("ui", {
        theme: "light",
        styles: { branding: { brandColor: "#b8860b" } },
        hideEventTypeDetails: false,
        layout: "month_view",
      });
    })();
  }, []);

  const handleClick = async () => {
    const cal = await getCalApi({ namespace: "30min" });
    cal("modal", {
      calLink: "pixiecliks/30min",
      config: {
        layout: "month_view",
        theme: "light",
      },
    });
  };

  return (
    <Button
      onClick={handleClick}
      className={className}
      variant="default"
      size="sm"
    >
      <Calendar className="mr-2 h-4 w-4" />
      Schedule a Free Consultation
    </Button>
  );
}
